<template>
    <div style="width: 100%; height: 100%">
        <div
            class="
                promotion-infographic
                d-flex
                flex-column
                justify-content-center
                align-items-center
            "
        >
            <img
                @click="onInfographicClick"
                :src="this.infographic && this.infographic.urls.medium"
                alt=""
            />
            <div
                v-if="maximize"
                @click="onInfographicClick"
                :class="{ 'promotion-infographic__maximize': maximize }"
                class="d-flex justify-content-center align-items-center mt-2"
            >
                <a-icon icon="Loupe" />
                <span class="ml-2">Kliknij, aby powiększyć</span>
            </div>
        </div>
        <UiImagePreview v-if="maximize" ref="viewer"></UiImagePreview>
    </div>
</template>

<script>
import UiImagePreview from '@/components/ui/UiImagePreview'
export default {
    name: 'promotionsInfographic',
    components: { UiImagePreview },
    props: {
        infographic: {
            type: Object,
            required: false
        },
        maximize: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    methods: {
        onInfographicClick() {
            if (!this.maximize) return
            this.$refs.viewer.show(
                [
                    {
                        source: this.infographic.urls.original
                    }
                ],
                0
            )
        }
    }
}
</script>
<style lang="scss" >
.promotion-infographic {
    &__maximize {
        cursor: pointer;
    }
}
</style>
